import React from "react";
import "./styles.css";

const PagSobre = () => {
    return (
        <section id="section-about" className="view-about">
            <p>About me</p>
            <p>
                Full Stack Developer, and freelance professional. Experienced in creating websites
                and applications, from the initial UX/UI design and prototyping stage to the
                complete implementation of Front-End and Back-End. Specialize in developing web
                applications with React JS and mobile apps with React Native.
            </p>
        </section>
    );
};

export default PagSobre;
